var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOvinoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 46.3499C22.66 43.7399 24.91 40.4999 27.7 40.1399C30.49 39.7799 36.43 40.5899 38.41 40.9499C40.39 41.3099 43.47 38.6599 44.1 37.9399C41.49 37.4899 37.91 36.3899 37.1 35.9399",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4099 35.44C45.8299 34.7 46.0399 34.13 45.9599 33.76",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.08 31.96C43.89 32.72 45.51 33.67 46.32 33.4C47.13 33.13 47.76 30.79 46.68 28.36C45.6 25.93 42.77 22.24 40.56 19.72C40.2 16.84 38.99 12.66 35.16 9.63995C33.23 8.11995 30.88 6.74995 28.09 5.94995C26.92 2.98995 19.97 2.44995 18.09 6.94995C13.38 4.61995 9.12997 7.77995 9.08997 11.9499C4.33997 11.2399 1.75997 17.2399 3.08997 19.9499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.31 16.95C10.24 18.48 9.44996 20.58 9.18996 22.97C8.61996 28.05 10.6 32.44 13.61 32.78C16.62 33.12 19.54 29.28 20.12 24.2C20.39 21.82 20.09 19.59 19.39 17.86",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOvinoWhite);
export default __webpack_public_path__ + "static/media/ic_ovino_white.1c887045670fde80a6228a9a36e5ba00.svg";
export { ForwardRef as ReactComponent };